var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56066 0.43934C10.1464 1.02513 10.1464 1.97487 9.56066 2.56066L3.62132 8.5L9.56066 14.4393C10.1464 15.0251 10.1464 15.9749 9.56066 16.5607C8.97487 17.1464 8.02513 17.1464 7.43934 16.5607L0.43934 9.56066C-0.146447 8.97487 -0.146447 8.02513 0.43934 7.43934L7.43934 0.43934C8.02513 -0.146447 8.97487 -0.146447 9.56066 0.43934Z",
    fill: "#29B095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.5C0 7.67157 0.671573 7 1.5 7H18C18.8284 7 19.5 7.67157 19.5 8.5C19.5 9.32843 18.8284 10 18 10H1.5C0.671573 10 0 9.32843 0 8.5Z",
    fill: "#29B095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullArrowLeft);
export default __webpack_public_path__ + "static/media/full-arrow-left.d35e4f83ab9a74c41d71855ed3147c8b.svg";
export { ForwardRef as ReactComponent };